import Modal, { ModalActionData } from '@betterfunnel/ui-core/Modal';
import TextField from '@betterfunnel/ui-core/TextField';
import { DialogTitle } from '@headlessui/react';
import { useEffect, useMemo, useState } from 'react';

interface Props {
  mention?: any;
  open: boolean;
  onClose: () => void;
  onSave: (mention: any) => void;
}

export default function EditQuillSearchParamMentionModal({
  mention,
  open,
  onClose,
  onSave,
}: Props) {
  const [searchParam, setSearchParam] = useState(mention?.searchParam ?? '');
  const [defaultValue, setDefaultValue] = useState(mention?.defaultValue ?? '');

  useEffect(() => {
    setSearchParam(mention?.searchParam ?? '');
    setDefaultValue(mention?.defaultValue ?? '');
  }, [open, mention]);

  const actions: ModalActionData[] = useMemo(
    () => [
      {
        title: 'Cancel',
        type: 'secondary',
        onClick: () => onClose(),
      },
      {
        title: 'Save',
        type: 'primary',
        onClick: () =>
          onSave({
            ...mention,
            searchParam,
            defaultValue,
            value: `${searchParam}`,
          }),
      },
    ],
    [defaultValue, mention, onClose, onSave, searchParam],
  );

  return (
    <Modal open={open} onClose={onClose} actions={actions}>
      <DialogTitle
        as="h3"
        className="text-base font-semibold leading-6 text-gray-900"
      >
        Update Search Param
      </DialogTitle>
      <div className="mt-4 flex min-h-48 flex-col gap-4">
        <TextField
          title="Variable Name"
          value={searchParam}
          onChange={(e) => setSearchParam(e.target.value)}
        />

        <TextField
          title="Default Value"
          value={defaultValue}
          onChange={(e) => setDefaultValue(e.target.value)}
        />
      </div>
    </Modal>
  );
}
